import { render } from "./SocialTwitter.vue?vue&type=template&id=7a26b3ac"
import script from "./SocialTwitter.vue?vue&type=script&lang=js"
export * from "./SocialTwitter.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__